import type { GoalSnapshotResponse } from "@repo/shared/types";
import { getWithToken } from "../_client";

const BASE = "/public/flow/goals";

export function getPublicGoalPortfolioSnapshot(token: string, goalId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/portfolio`, token);
}

export function getPublicGoalXraySnapshot(token: string, goalId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/xray`, token);
}

export function getPublicGoalAssetAllocationSnapshot(token: string, goalId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/asset-allocation`, token);
}

export function getPublicGoalHistoricalReturnSnapshot(token: string, goalId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/historical-return`, token);
}

export function getPublicGoalForecastSnapshot(token: string, goalId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/forecast`, token);
}

export function getPublicGoalCostSnapshot(token: string, goalId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/cost`, token);
}

export function getPublicGoalExpectedValueSnapshot(token: string, goalId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/expected-value`, token);
}

// QL-315 — client-visible: the mix of what is being offered, with no bound
// values, no metrics and no decision affordance to withhold.
export function getPublicGoalAssetClassForecastSnapshot(token: string, goalId: string) {
  return getWithToken<GoalSnapshotResponse>(
    `${BASE}/${goalId}/snapshot/asset-class-forecast`,
    token,
  );
}
